import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Icon } from '../../../../common/components/icons';
import { sizeEnum } from '../../../../common/components/icons/Icon';
import Tooltip from '../../../../common/components/Tooltip';
import useStyles from './SharedRowColumn.styles';

const SharedRowColumn = ({ sharedRow }) => {
  const classes = useStyles();
  if (sharedRow) {
    return (
      <div className={classes.container}>
        <Tooltip title={i18n.t('mission.message.sharedRow')} placement="bottom">
          <Icon icon="check" size={sizeEnum.small} />
        </Tooltip>
      </div>
    );
  }
  return <span />;
};

SharedRowColumn.propTypes = {
  sharedRow: PropTypes.bool,
};

SharedRowColumn.defaultProps = {
  sharedRow: false,
};

export default SharedRowColumn;
